export const pickMediaPlanOverlapAnnotation = (
  annotation: { startDate: string; endDate?: string | null },
  mediaPlan: { date_range: { start_date: string; end_date: string } },
) => {
  const annotationStartDate = new Date(annotation.startDate);
  const annotationEndDate = new Date(
    annotation.endDate ?? annotation.startDate,
  );
  const mediaPlanStartDate = new Date(mediaPlan.date_range.start_date);
  const mediaPlanEndDate = new Date(mediaPlan.date_range.end_date);

  return (
    // Check if annotation start date is within the mediaPlan
    (annotationStartDate.getTime() <= mediaPlanEndDate.getTime() &&
      annotationStartDate.getTime() >= mediaPlanStartDate.getTime()) ||
    // Check if annotation end date is within the mediaPlan
    (annotationEndDate.getTime() <= mediaPlanEndDate.getTime() &&
      annotationEndDate.getTime() >= mediaPlanStartDate.getTime()) ||
    // Checks if start and end date overlaps with mediaPlan
    (annotationStartDate.getTime() <= mediaPlanEndDate.getTime() &&
      annotationEndDate.getTime() >= mediaPlanStartDate.getTime()) ||
    // Checks if start and end date overlaps with mediaPlan
    (annotationStartDate.getTime() >= mediaPlanStartDate.getTime() &&
      annotationEndDate.getTime() <= mediaPlanEndDate.getTime())
  );
};
